import{useRef as r}from"react";const t=t=>{const o=r(t);return o.current=t,o};export{t as useDataRef};
